<template>
	<div class="appPage" ref="videoRoll">
		<img src="../assets/banner.png" class="banner" />
		<img :src="ossLink + 'img1/titleVideo.png'" class="titleVideo" />
		<a :href="item.address" target="_blank" class="videoBox" v-for="(item, index) in videoList"
			:key="'vid_' + index">
			<img :src="item.photo" v-if="item.photo" />
			<div class="img" v-if="!item.photo"></div>
			<p v-if="item.title != '' && item.title != null">{{ item.title }}</p>
		</a>
		<!-- <div v-else>
                <img :src="item.photo" />
                <p v-if="item.title != '' && item.title != null">{{ item.title }}</p>
            </div> -->
		<Back :linkTo="'/'" />
	</div>
</template>

<script>
	export default {
		name: 'HelloWorld',
		data() {
			return {
				ossLink: 'https://oss.eventnet.cn/H5/kwaiPlay/',
				videoList: []
			};
		},
		created() {
			const THAT = this;
			THAT.videoSet();
		},
		mounted() {
			const THAT = this;
			THAT.$refs.videoRoll.scrollTop = 0;
		},
		methods: {
			jumpTo(uid) {
				const THAT = this;
				localStorage.setItem('video-kwai', JSON.stringify(THAT.videoList[uid]));
				THAT.$router.push('/Play').catch(err => err);
			},
			videoSet() {
				const THAT = this;
				THAT.axios.get('https://oss.eventnet.cn/H5/kwaiPlay/img1/request1.json?v=' + new Date().getTime()).then(
					res => {
						THAT.videoList = res.video;
					}).catch(err => {
					console.log(err);
				});
			}
		}
	};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
	.appPage {
		min-height: 100vh;
		background: url('../assets/bg1.jpg') no-repeat;
		background-size: 100%;
		background-position: center bottom;
		padding-top: 50px;
		padding-bottom: 150px;

		.banner {
			width: 691px;
			height: 387px;
			margin: 0 auto;
		}

		.titleVideo {
			width: 353px;
			height: 106px;
			margin: 50px auto;
		}
	}

	.videoBox {
		position: relative;
		z-index: 2;
		width: 692px;
		background-color: #2945d4;
		border-radius: 10px;
		margin: 0 auto 40px;
		display: block;
		color: #fff;
		padding: 20px 0;

		&::before {
			content: '';
			position: absolute;
			top: 165px;
			left: 50%;
			z-index: 5;
			display: block;
			margin-left: -40px;
			width: 80px;
			height: 80px;
			background: #fff url('https://oss.eventnet.cn/H5/kwaiPlay/img/24gf-playCircle.png') no-repeat;
			background-size: 100% 100%;
			border-radius: 50%;
			opacity: 0.5;
			animation: breathing 5s linear infinite;
			transform: scale(0.8);
			pointer-events: none;
		}

		img {
			width: 671px;
			height: 365px;
			border-radius: 5px;
			pointer-events: all;
			background: #fc591b;
			margin: 0 auto;
		}

		.img {
			width: 671px;
			height: 365px;
			border-radius: 5px;
			pointer-events: all;
			background: #fc591b;
			margin: 0 auto;
			border: none;
		}

		p {
			font-size: 28px;
			line-height: 36px;
			text-align: center;
			margin: 20px;
			overflow: hidden;
			text-overflow: ellipsis;
			display: -webkit-box;
			-webkit-line-clamp: 2;
			-webkit-box-orient: vertical;
		}
	}
</style>